import '../../../../pages/Organization/OrganizationOld.scss';

import { Modal } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';

type Props = {
  isModalOn: boolean;
  setIsModalOn: (isModalOn: boolean) => void;
  selected: string[];
};

export const DeleteInvitationsModal = observer(({ isModalOn, setIsModalOn, selected }: Props) => {
  const { t } = useTranslation();
  const iss = useStores().inviteStudentsStore;
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);

  return (
    <Modal
      open={isModalOn}
      onClose={() => setIsModalOn(false)}
      aria-labelledby={t('DeleteInvitations', { ns: 'studentsPage' })}
      aria-describedby={t('DeleteInvitationsFromTheList', { ns: 'studentsPage' })}
      cancelBtn={{
        label: t('Cancel', { ns: 'general' }),
        onClick: () => setIsModalOn(false),
        className: 'styled-button secondary',
      }}
      confirmBtn={{
        label: t('Delete', { ns: 'studentsPage' }),
        onClick: () => {
          iss.deleteInvitesAndUpdate(selected, selectedOrganizationId);
          setIsModalOn(false);
        },
      }}
      title={t('DeleteInvitations', { ns: 'studentsPage' })}
      titleIcon={<TrashIcon />}
    >
      <div className='modal-body'>
        <Paragraph>
          <strong>{t('AreYouSureYouWantToDeleteInvitationsFromTheList', { ns: 'studentsPage' })}</strong>
        </Paragraph>
        <Paragraph>
          <>{t('InvitationsWillNotBeDeletedFromRecipientsEmail', { ns: 'studentsPage' })}</>
        </Paragraph>
      </div>
    </Modal>
  );
});

export default DeleteInvitationsModal;
